//COMPONENTS
import DashBoardHeader from "../../components/DashboardHeader";
import { Background, StyledGreetings, StyledApplication } from "./styled";
import { Container } from "../../styles/Container";
import NotLoggedPage from "../NotLogged";
import TechList from "../../components/TechList";
import AddModal from "../../components/AddModal";
import { StyledBtn } from "../../styles/Buttons";
import DetailsModal from "../../components/DetailsModal";

//LIBS
import { Navigate, useNavigate } from "react-router-dom";

//CONTEXT
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";

import { TechContext } from "../../context/TechContext";

const DashBoard = ()=>{

    const token = localStorage.getItem("@kenzie-hub: logged-user-token")

    const navigate = useNavigate();
    const {user, leaveProfile} = useContext(UserContext);
    const { viewDetails, detailsModal,
            setDetailsModal, addModal,
            setAddModal, getTechs} = useContext(TechContext);

    
    const closeAddModal = ()=>{
        setAddModal(false);
        return addModal
    }
    const closeDetailsModal = ()=>{
        setDetailsModal(false);
    }

    if(!token){
        return <Navigate to="/login"/>
    }

    return(
        <>
            <Background>
                <DashBoardHeader leaveFunction={leaveProfile}/>
                <main>
                    <StyledGreetings>
                        <Container>
                            <h2>Olá, <span>{user?.name}</span></h2>

                            <p>{user?.course_module}</p>
                        </Container>
                    </StyledGreetings>
                    <StyledApplication>
                        <Container>
                            <h1>Tecnologias</h1>
                            <StyledBtn onClick={()=>setAddModal(true)} small size="70px" BGcolor="var(--color-grey-3)">+</StyledBtn>
                        </Container>
                        <Container>
                            <TechList/>
                        </Container>
                    </StyledApplication>
                </main>
            </Background>
            {
                addModal && <AddModal closeModal={closeAddModal}/>
            }
            {
                detailsModal && <DetailsModal tech={viewDetails} closeModal={closeDetailsModal}/>
            }
        </>
        
    );

}

export default DashBoard